import { DataTableSort } from 'studio-components';
import { createAction, props } from '@ngrx/store';
import { ApiKeyApiError } from './api-key.errors';
import { ApiKey, ApiKeyCreationParams } from './api-key.model';
import { ApiKeyUpdateParams } from '../api-key-form/api-key-form.model';

export enum ApiKeyActionTypes {
  ApiKeyPageLoadedAction = '[Api Key Page] Page Loaded',
  ApiKeyPageRequestedAction = '[Api Key Page] Page Requested',
  NewApiKeySubmittedAction = '[Api Key Page] New Api Key Submitted',
  ApiKeyCreatedAction = '[Api Key Effect] Api Key Created Successfully',
  UpdateApiKeySubmittedAction = '[Api Key Page] Update Api Key Submitted',
  ApiKeyUpdatedAction = '[Api Key Effect] Api Key Updated Successfully',
  ApiKeySortChangedAction = '[Api Key Effect] Api Key Sort Changed',
  ApiKeysLoadedAction = '[Api Key Effect] Api Keys Loaded',
  ApiKeysErroredAction = '[Api Key Effect] Api Keys Errored',
  ApiKeyRevokeRequestedAction = '[Api Key Page] Revoke Api Key ',
  ApiKeyRevokeRequestedSuccessAction = '[Api Key Page] Revoke Api Key Success',
  ApiKeyRevokeRequestedFailedAction = '[Api Key Page] Revoke Api Key Failed',
}

export const ApiKeyPageLoadedAction = createAction(ApiKeyActionTypes.ApiKeyPageLoadedAction);

export const ApiKeySortChangedAction = createAction(
  ApiKeyActionTypes.ApiKeySortChangedAction,
  props<{ sort: DataTableSort }>(),
);

export const ApiKeyPageRequestedAction = createAction(ApiKeyActionTypes.ApiKeyPageRequestedAction);

export const NewApiKeySubmittedAction = createAction(
  ApiKeyActionTypes.NewApiKeySubmittedAction,
  props<{ apiKey: ApiKeyCreationParams }>(),
);

export const ApiKeyCreatedAction = createAction(ApiKeyActionTypes.ApiKeyCreatedAction);

export const UpdateApiKeySubmittedAction = createAction(
  ApiKeyActionTypes.UpdateApiKeySubmittedAction,
  props<{ apiKeyId: number; apiKey: ApiKeyUpdateParams }>(),
);

export const ApiKeyUpdatedAction = createAction(
  ApiKeyActionTypes.ApiKeyUpdatedAction,
  props<{ apiKey: ApiKey }>(),
);

export const ApiKeysLoadedAction = createAction(
  ApiKeyActionTypes.ApiKeysLoadedAction,
  props<{ apiKeys: ApiKey[] }>(),
);

export const ApiKeysErroredAction = createAction(
  ApiKeyActionTypes.ApiKeysErroredAction,
  props<{ error: ApiKeyApiError }>(),
);

export const ApiKeyRevokeRequestedAction = createAction(
  ApiKeyActionTypes.ApiKeyRevokeRequestedAction,
  props<{ apiKeyId: number }>(),
);
export const ApiKeyRevokeRequestedSuccessAction = createAction(
  ApiKeyActionTypes.ApiKeyRevokeRequestedSuccessAction,
);
export const ApiKeyRevokeRequestedFailedAction = createAction(
  ApiKeyActionTypes.ApiKeyRevokeRequestedFailedAction,
  props<{ error: ApiKeyApiError }>(),
);
